import React, { useState, useRef, useMemo, useCallback, forwardRef } from "react";
import PropTypes from "prop-types";
import { Popover, TextField } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useIntl } from "react-intl";

import { countries } from "../../../../../_common/utils/phone/data";
import { DEFAULT_COUNTRY } from "../../../../../_common/utils/phone/maskConfig";
import { Container, SCList, SCListItem } from "./styles";
import { storage } from "../../../../../utils/storage";
import { COD_1_DDI_TELEFONE_PAISES, obterChaveDicCountry } from "../../../../../_common/utils/phone";

const storageKey = "countries.last_used";

const SelectDDI = forwardRef(({ value, onChange, onBlur, disabled, className, ...props }, ref) => {
  const intl = useIntl();
  const chaveDictionarySelecionado = ref?.current;
  const chaveDictionaryCountry = obterChaveDicCountry(value, props.inputProps?.numero, chaveDictionarySelecionado);

  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const [filter, setFilter] = useState("");

  const onSelect = useCallback((callingCode, chaveDic) => {
    const lastUsed = storage.get(storageKey, []);
    lastUsed.unshift(callingCode === COD_1_DDI_TELEFONE_PAISES ? chaveDic : callingCode);
    storage.set(storageKey, [...new Set(lastUsed.splice(0, 6))]);
    setOpen(false);
    setFilter("");
    onChange(callingCode, chaveDic);
    if (onBlur) onBlur(callingCode);
  }, []);

  const countriesList = useMemo(() => {
    const lastUsed = {};
    storage
      .get(storageKey, [DEFAULT_COUNTRY])
      .reverse()
      .forEach((x, i) => {
        lastUsed[x] = i + 1;
      });

    return Object.entries(countries)
      .sort(([, a], [, b]) => a.name.localeCompare(b.name))
      .map(([key, x]) => ({
        ...x,
        key,
        pos: lastUsed[key] || 0,
      }))
      .sort((a, b) => b.pos - a.pos);
  }, []);

  const selected = useMemo(
    () => {
      let country = countries[chaveDictionaryCountry];
      if (!country) {
        country = countries[DEFAULT_COUNTRY];
        onChange(country.callingCode);
      }
      return country;
    },
    [chaveDictionaryCountry]
  );

  return (
    <Container ref={containerRef} disabled={disabled} className={className}>
      <button
        type="button"
        onClick={() => {
          if (disabled) return;
          setOpen(true);
          setFilter("");
        }}
      >
        <img src={selected.flag} alt={selected.name} />
        <ArrowDropDownIcon />
      </button>

      <Popover
        open={open}
        anchorEl={containerRef?.current}
        anchorOrigin={{ horizontal: "center", vertical: "center" }}
        onClose={() => {
          setOpen(false);
          setFilter("");
          if (onBlur) onBlur(value);
        }}
      >
        <TextField
          id="filtro-paises"
          label={intl.formatMessage({ defaultMessage: "Pesquisar" })}
          placeholder={intl.formatMessage({ defaultMessage: "Pesquisar" })}
          type="search"
          margin="dense"
          onChange={e => setFilter(e.target.value)}
          style={{ width: "94%", margin: "8px 12px" }}
        />
        <SCList component="nav" id="listaPaises">
          {countriesList
            ?.filter(
              x => x.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase()) || x.callingCode.includes(filter)
            )
            .map(c => (
              <SCListItem
                key={c.name}
                selected={c.key === chaveDictionaryCountry}
                onClick={() => {
                  onSelect(c.callingCode, c.key);
                }}
              >
                <img src={c.flag} alt={c.alpha2Code} />
                <b>{c.name}</b>
                <p>+{c.callingCode}</p>
              </SCListItem>
            ))}
        </SCList>
      </Popover>
    </Container>
  );
});

SelectDDI.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  props: PropTypes.object,
  inputProps: PropTypes.object,
  numero: PropTypes.string,
};

export default SelectDDI;
